import { Injectable } from '@angular/core';
import { Observable, tap, catchError, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { GenericService } from '../generic.service';
import {
  MindlerTestRequest,
  AddMindlerTestRequest,
  MindlerTestRequestResponse
} from '../../models/psychometric-test/psychometric-test.model';

@Injectable({
  providedIn: 'root',
})
export class MindlerTestRequestService {
  private readonly baseUrl = 'mindler/testrequest';
  private readonly apiBaseUrl = environment.apis.default.baseUrl + environment.apis.default.url;

  constructor(
    private genericService: GenericService,
    private httpClient: HttpClient
  ) { }

 
  getTestRequest(): Observable<MindlerTestRequestResponse> {
    return this.genericService.get<MindlerTestRequestResponse>(`${this.baseUrl}`);
  }

 
  createTestRequest(type: 1 | 2): Observable<MindlerTestRequestResponse> {
    const payload: AddMindlerTestRequest = { assessmentType: type };
    const fullUrl = `${this.baseUrl}`;

    const fullApiUrl = `${this.apiBaseUrl}/${fullUrl}`;

    return this.httpClient.post<MindlerTestRequestResponse>(fullApiUrl, payload, {
      responseType: 'json'
    });

  }
}
